import { h, Component } from "preact";
import { css } from "emotion";
import OrganiserService from "../../services/OrganiserService";
import Image from "../../components/Image";

const fbIcon = require("../../assets/images/icon-facebook-grey.svg");
const twitterIcon = require("../../assets/images/icon-twitter-grey.svg");
const instagramIcon = require("../../assets/images/icon-instagram.svg");
const linkedInIcon = require("../../assets/images/ic_linkedin.svg");

const styles = {
  wrapper: css`
    width: 100%;
    max-width: 280px;
    border-radius: 4px;
    background-color: #ffffff;
    padding: 24px;
    @media (max-width: 600px) {
      max-width: 100%;
    }
  `,
  link: css`
    margin: 0 12px;
  `,
  icon: css`
    width: 32px;
  `
};

const OrganiserSocial = ({ twitter, facebook, instagram, linkedIn }) => {
  return (
    <div className={styles.wrapper}>
      {facebook ? (
        <a
          href={OrganiserService.sanitiseURLs(facebook)}
          className={styles.link}
          target="_blank"
        >
          <Image src={fbIcon} alt="Facebook Icon" className={styles.icon} />
        </a>
      ) : null}
      {twitter ? (
        <a
          href={OrganiserService.sanitiseURLs(twitter)}
          className={styles.link}
          target="_blank"
        >
          <Image src={twitterIcon} alt="Twitter Icon" className={styles.icon} />
        </a>
      ) : null}
      {instagram ? (
        <a
          href={OrganiserService.sanitiseURLs(instagram)}
          className={styles.link}
          target="_blank"
        >
          <Image
            src={instagramIcon}
            alt="Instagram Icon"
            className={styles.icon}
          />
        </a>
      ) : null}
      {linkedIn ? (
        <a
          href={OrganiserService.sanitiseURLs(linkedIn)}
          className={styles.link}
          target="_blank"
        >
          <Image
            src={linkedInIcon}
            alt="Linked In Icon"
            className={styles.icon}
          />
        </a>
      ) : null}
    </div>
  );
};

export default OrganiserSocial;



// WEBPACK FOOTER //
// ./routes/organiser/OrganiserSocial.js